export const FETCH_CASHBACK_START = "FETCH_CASHBACK_START";
export const FETCH_CASHBACK_SUCCESS = "FETCH_CASHBACK_SUCCESS";
export const FETCH_CASHBACK_FAILED = "FETCH_CASHBACK_FAILED";